import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";

export const SiteLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white pb-[84px] lg:pb-0">
      <a href="#inhalt" className="sr-only z-[60] rounded-lg bg-brand-anthracite px-4 py-2 text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4">
        Zum Inhalt springen
      </a>
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <MobileBar />
    </div>
  );
};
